module.exports = __webpack_public_path__ + "static/img/RSG2-24V5A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSG2-24V5A_1.png
// module id = 8YWE
// module chunks = 0